/**
 * returns Notification states and false if browser does not support it
 * @returns {false,"denied","granted","default"}
 */
export const getBrowserNotifPermissionState = () => {
  if (!("Notification" in window)) {
    return false;
  }

  return Notification?.permission;
};

// This function checks if notification is enabled or not. nad passes the result to the callback function
export const checkNotificationPermission = (cb = () => {}) => {
  const notifState = getBrowserNotifPermissionState();

  if (!notifState) return;

  // if user has blocked or has not decided about notif permission yet
  if (["denied", "default"].includes(notifState)) {
    cb(false);
    return;
  }

  cb(true);
};
